exports.baseURL = "https://appadmin.vibelynk.com/";
exports.key = "OofTOfK5wrHUpdMcbnzDSd1D3zDH3KkE";
//exports.key = "D77GcGh9DV04xtHH419tK1xsHA6p6x5U";

// exports.baseURL = "http://localhost:5000/";
